import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import {errorHandler} from "@/services/errorHandler";
import transactionManager from "@/store/modules/transactionManager";
import TimeModule from "@/store/modules/time-module";
import auth from "@/store/modules/auth";
import locations from "@/store/modules/locations";
import Kazang from "@/store/modules/Kazang";

import VuexPersistence from 'vuex-persist';
import { set, get, del, createStore } from 'idb-keyval';

// Create custom IDB store that handles missing stores gracefully
const customStore = createStore('vuex-persist', 'keyval');

const safeGet = async (key) => {
    try {
        return await get(key, customStore);
    } catch (err) {
        console.warn('IndexedDB get error:', err.message);
        return undefined;
    }
};

const safeSet = async (key, value) => {
    try {
        await set(key, value, customStore);
    } catch (err) {
        console.warn('IndexedDB set error:', err.message);
    }
};

const safeDel = async (key) => {
    try {
        await del(key, customStore);
    } catch (err) {
        console.warn('IndexedDB del error:', err.message);
    }
};

const indexedDBStorage = {
    getItem: safeGet,
    setItem: safeSet,
    removeItem: safeDel
};

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    storage: indexedDBStorage, // Use IndexedDB
    asyncStorage: true, // Enable async storage handling
    restoreState: async (key) => {
        try {
            const value = await safeGet(key);
            // console.log('Restoring state from IndexedDB:', { key, value });
            return value || {};
        } catch (err) {
            console.error('Error restoring state:', err);
            return {};
        }
    },
    saveState: async (key, value) => {
        try {
            // console.log('Saving state to IndexedDB:', { key, value });
            await safeSet(key, value);
        } catch (err) {
            console.error('Error saving state:', err);
        }
    }
});

const store = new Vuex.Store({
    state: {
        // apiKey: '5c685245-70eb-4eea-994c-6a333085ec7f',//dump
       // apiKey: '744ddfre-55eedff69-qzzwd2',//live
        loading: false,
    },
    getters: {
        getApiKey: state => state.apiKey,
        getLoadingState: (state) => state.loading,
    },
    mutations: {
        setLoadingState: (state, payload) => state.loading = payload,
    },
    actions: {
        sendRequest(context, {url, payload, headers, method}) {
            const maxRetries = 3;
            let currentRetry = 0;
            if (!payload.localid){
                payload.localid = generateUUID();
            }

            const attemptRequest = () => {
                return axios[method](url, payload, {
                    headers: headers || {}
                }).then(({data}) => {
                    if (!data.processed) {
                        // Check if the response indicates unprocessed data and if retries are available
                        if (currentRetry < maxRetries) {
                            currentRetry++;
                            console.log(`Attempt ${currentRetry}: Data unprocessed, retrying...`);
                            return attemptRequest(); // Retry the request
                        }
                        // Throw an error if max retries are reached with unprocessed data
                        throw new Error('Data still unprocessed after maximum retries : ' + maxRetries);
                    }
                    return data.response; // Return the response if data is processed
                }).catch(err => {
                    if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
                        if (currentRetry < maxRetries) {
                            currentRetry++;
                            console.log(`Attempt ${currentRetry}: Retrying...`);
                            return attemptRequest(); // Retry the request
                        }
                    }
                    throw err; // Re-throw the error if it's not a timeout or retries are exhausted
                });
            };
            return attemptRequest()
                .then(response => {
                    payload.localid = null;
                    return response
                })
                .catch(err => errorHandler.tomcatError(err));
        },
        getCompanyLogo(context, payload) {

        }
    },
    modules: {
        transactionManager,TimeModule,auth,locations,Kazang
    },
    plugins: [
        vuexLocal.plugin,
    ],
})
export default store;

